module.exports = __webpack_public_path__ + "static/media/powered_by_copiri.7d98ede6.png";